// Sonido de zumbadores con Web Audio (una voz por pieza).
export class Audio {
  constructor() {
    this.ctx = null;
    this.voices = new Map();
    this.muted = false;
  }

  /** Debe llamarse desde un gesto del usuario (clic en Simular). */
  resume() {
    try {
      if (!this.ctx) this.ctx = new (window.AudioContext || window.webkitAudioContext)();
      if (this.ctx.state === 'suspended') this.ctx.resume();
    } catch {
      this.ctx = null;
    }
  }

  set(id, freq, volume = 1) {
    if (!this.ctx) return;
    let v = this.voices.get(id);
    const on = freq > 0 && volume > 0 && !this.muted;
    const t = this.ctx.currentTime;
    if (!on) {
      if (v) v.gain.gain.setTargetAtTime(0, t, 0.008);
      return;
    }
    if (!v) {
      const osc = this.ctx.createOscillator();
      osc.type = 'square';
      const filter = this.ctx.createBiquadFilter();
      filter.type = 'lowpass';
      filter.frequency.value = 6000;
      const gain = this.ctx.createGain();
      gain.gain.value = 0;
      osc.connect(filter).connect(gain).connect(this.ctx.destination);
      osc.start();
      v = { osc, gain };
      this.voices.set(id, v);
    }
    v.osc.frequency.setTargetAtTime(freq, t, 0.003);
    v.gain.gain.setTargetAtTime(0.045 * Math.min(1, volume), t, 0.004);
  }

  stopAll() {
    for (const v of this.voices.values()) {
      try {
        v.gain.gain.setTargetAtTime(0, this.ctx.currentTime, 0.01);
        v.osc.stop(this.ctx.currentTime + 0.1);
      } catch {
        // ya detenida
      }
    }
    this.voices.clear();
  }
}
